export default "__VITE_ASSET__DjX_$Ign__"